// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

import { ModuleManager } from './moduleManager'


// Create and configure module manager
const moduleManager = new ModuleManager()

// Register all modules with their selectors
moduleManager
  .register('.js-faq', 'faq')
  .register('.js-slider', 'slider')
  .register('.js-mobile-menu-toggle', 'mobileMenu')
  .register('.js-job-form', 'jobForm')

  .registerAdmin('Faq', 'faq')
  .registerAdmin('Slider', 'slider')
  .registerAdmin('JobForm', 'jobForm')

// Initialize modules
moduleManager.init()